import Modal from "src/pages/Modals/ModalBase";
import { useSelector } from "react-redux";
import { setUnsupportFilePopup } from "src/store/slices/messageSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { trackAnalytics } from "src/pages/helpers";
import { BUTTON_ROLES, BUTTON_TYPES, EVENT_NAMES, EVENT_PARAMETERS, getPageName, MODAL_NAMES } from "src/utils/EventConstants";
const UnsupportedFileFormat = () => {
  const dispatch = useDispatch();
  const unsupportFilePopup = useSelector((state) => state.messageSlice.unsupportFilePopup);
  const unsupportedFileName = useSelector((state) => state.messageSlice.unsupportedFileName);
  const unsupportedFileFormat = useSelector((state) => state.messageSlice.unsupportedFileFormat);
  const threadData = useSelector((state) => state.messageSlice.threadData);
  const userMetadata = useSelector((state) => state.onboarding.userMetadata);

  useEffect(() => {
    if (unsupportFilePopup) {
      // Event 23:
      trackAnalytics(
        EVENT_NAMES.VIEWED_MODAL,
        {
          [EVENT_PARAMETERS.PAGE_NAME]: getPageName(),
          [EVENT_PARAMETERS.THREAD_ID]: threadData?.id,
          [EVENT_PARAMETERS.CURRENT_PLAN_TIER]: userMetadata?.subscription_type || "anonymous",
          [EVENT_PARAMETERS.USER_ID]: userMetadata?.id,
          [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.UNSUPPORTED_FILE_FORMAT,
          filename: unsupportedFileName,
          unsupportedFileFormat: unsupportedFileFormat,
        },
        userMetadata,
      );
    }
  }, [unsupportFilePopup]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Modal
      isOpen={unsupportFilePopup}
      bodyStyle={{ paddingBottom: "0px", borderRadius: "16px", paddingTop: "0px" }}
      className="w-[700px]"
      onClose={() => {
        // Event 24:
        trackAnalytics(
          EVENT_NAMES.CLICKED_BUTTON,
          {
            [EVENT_PARAMETERS.PAGE_NAME]: getPageName(),
            [EVENT_PARAMETERS.THREAD_ID]: threadData?.id,
            [EVENT_PARAMETERS.BUTTON_TYPE]: BUTTON_TYPES.BUTTON_WITH_ICON,
            [EVENT_PARAMETERS.CURRENT_PLAN_TIER]: userMetadata?.subscription_type || "anonymous",
            [EVENT_PARAMETERS.BUTTON_ROLE]: BUTTON_ROLES.NAVIGATION_CLOSE,
            [EVENT_PARAMETERS.USER_ID]: userMetadata?.id,
            [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.UNSUPPORTED_FILE_FORMAT,
          },
          userMetadata,
        );
        dispatch(setUnsupportFilePopup(false));
      }}
    >
      <div data-testid="unsupported-file-popup" className="w-full md:w-[800px] md:h-[350px] gap-[16px] md:gap-[32px] bg-white rounded-lg shadow-lg flex flex-col p-[32px]">
        <h2 data-testid="unsupported-file-heading" className="text-[16px] md:text-[24px] font-semibold font-sans text-[#353535]">Unsupported file format</h2>
        <hr></hr>
        <div className="flex flex-col gap-[8px]">
          <p className="font-medium text-[14px] md:text-[18px] leading-[28px] font-sans text-[#686868]">
            The file format you uploaded isn’t currently supported. At this time, we accept PDF (.pdf), DOCX (.docx),
            and image (.jpg, .jpeg, .png) files.
          </p>
          <p className="font-semibold text-[14px] md:text-[18px] font-sans text-[#353535] my-2">
            Please upload your document in one of these formats.
          </p>
        </div>
        <div className="flex justify-end mt-2 space-x-4">
          <button
            onClick={() => {
              // Event 25:
              trackAnalytics(
                EVENT_NAMES.CLICKED_BUTTON,
                {
                  [EVENT_PARAMETERS.PAGE_NAME]: getPageName(),
                  [EVENT_PARAMETERS.THREAD_ID]: threadData?.id,
                  [EVENT_PARAMETERS.BUTTON_TYPE]: BUTTON_TYPES.BUTTON_WITH_TEXT,
                  [EVENT_PARAMETERS.BUTTON_TEXT]: "Ok got it",
                  [EVENT_PARAMETERS.CURRENT_PLAN_TIER]: userMetadata?.subscription_type || "anonymous",
                  [EVENT_PARAMETERS.BUTTON_ROLE]: BUTTON_ROLES.NAVIGATION_NEXT,
                  [EVENT_PARAMETERS.USER_ID]: userMetadata?.id,
                  [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.UNSUPPORTED_FILE_FORMAT,
                },
                userMetadata,
              );
              dispatch(setUnsupportFilePopup(false));
            }}
            data-testid="unsupported-file-ok-btn"
            className="btn-base btn-secondary flex justify-center w-full md:w-auto  text-[14px] md:text-[16px]"
          >
            Ok, got it
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UnsupportedFileFormat;
